import { criarSessaoWaPayload } from '../../interfaces/wa'
import BASEAPI from '../api/gesttor'

export function iniciarSessaoWa(payload: criarSessaoWaPayload) {
    return BASEAPI.put('/wa/sessao', payload)
}

export function dadosWa() {
    return BASEAPI.get(`/wa/sessao`)
}

export function atualizarIntegracaoWa() {
    return BASEAPI.patch(`/wa/sessao`)
}

export function sincronizarModelosWa() {
    return BASEAPI.post('/wa/modelos')
}